import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../actions/root_url';

export const getImageUrl = (formData, success) => {
  axios({
    method: 'POST',
    url: `${ROOT_URL}v1/customer/upload_file`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    data: formData,
  })
    .then(res => {
      success(res.data);
    })
    .catch(err => {
      failed();
    })
}



// WEBPACK FOOTER //
// ./master/jsx/components/Customers/apis.js